import {
  NAV_TYPE,
  useCurrentNavigationValues,
  useNavigation,
} from '@innovamat/ga-features';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSitemapNavigation } from './use-sitemap-navigation';

function useRedirectSitemapNotFound(): void {
  const { pathname } = useLocation();
  const { menu } = useParams();
  const { navigateInSameNavType } = useNavigation();
  const { isPageIdAsSubmenu, getAllAvailableRoutes, getFirstSitemapRoute } =
    useSitemapNavigation();
  const { navType, currentRoute } = useCurrentNavigationValues();

  const allRoutes = getAllAvailableRoutes();

  const navigateToFirstRoute = (): void => {
    const firstSitemapRoute = getFirstSitemapRoute();

    if (firstSitemapRoute) {
      navigateInSameNavType(firstSitemapRoute);
    }
  };

  useEffect(() => {
    // If the user is in the admin section, we only want to redirect to the first route the first time
    if (navType === NAV_TYPE.Admin && !menu) {
      navigateToFirstRoute();
      return;
    }

    if (allRoutes.length === 0 || navType === NAV_TYPE.Admin) {
      return;
    }

    if (!allRoutes.includes(currentRoute!) && !isPageIdAsSubmenu) {
      navigateToFirstRoute();
    }
  }, [allRoutes, pathname]);
}

export { useRedirectSitemapNotFound };
